import type { ApiEnvelope } from '../types';

// Same base resolution as useAPI: empty in dev (Vite proxies /api), set to the
// Worker origin at build time via VITE_API_BASE_URL for production.
export const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

async function unwrap<T>(res: Response): Promise<T> {
  const body = (await res.json()) as ApiEnvelope<T>;
  if (!res.ok || !body.ok) {
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  return body.data;
}

export async function getJSON<T>(path: string): Promise<T> {
  return unwrap<T>(await fetch(`${API_BASE}${path}`));
}

export async function postJSON<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return unwrap<T>(res);
}

/** Minimal header parse (first CSV line), mirrors the server parser's quoting. */
export function parseCsvHeaders(csv: string): string[] {
  const firstLine = (csv ?? '').replace(/\r\n/g, '\n').split('\n').find((l) => l.trim() !== '');
  if (!firstLine) return [];
  const out: string[] = [];
  let field = '';
  let inQuotes = false;
  for (let i = 0; i < firstLine.length; i++) {
    const ch = firstLine[i];
    if (inQuotes) {
      if (ch === '"') {
        if (firstLine[i + 1] === '"') {
          field += '"';
          i++;
        } else inQuotes = false;
      } else field += ch;
    } else if (ch === '"') inQuotes = true;
    else if (ch === ',') {
      out.push(field.trim());
      field = '';
    } else field += ch;
  }
  out.push(field.trim());
  return out;
}
